const stripCompanyId = (companyId: string) => {
  if (companyId) {
    return companyId.replace(/\./g, '');
  }
  return companyId;
};

export default stripCompanyId;
